// Bookable durations in minutes: 15-minute steps up to a whole day.
export const DURATION_MINUTES: number[] = Array.from({ length: 1440 / 15 }, (_, i) => (i + 1) * 15);
